import HttpClient from '@/utils/HttpClient';

export default {
  setActiveProjectId(id) {
    return HttpClient.postAuthenticated(`/api/me/activeProject`, { projectId: id });
  },
  getUserInfo() {
    return HttpClient.getAuthenticated(`/api/me`);
  },
  getUserPicture() {
    return HttpClient.getAuthenticated(`/api/me/picture`);
  },
  setUserPicture(picture) {
    return HttpClient.postAuthenticated(`/api/me/picture`, { picture });
  },
  sendPwResetMail() {
    return HttpClient.getAuthenticated(`/api/me/sendPwResetMail`);
  }
};
